'use client'

import React from 'react'
import { Layout } from 'antd'

const { Footer } = Layout

const ComponentFooter = () => {
  return (
    <Footer className='footer'>Developed by SCGINTL 2023</Footer>
  )
}

export default ComponentFooter